import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Smoothly scrolls window to top whenever the route pathname changes.
 * Does NOT scroll on query-string changes or hash navigation — only on path.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use 'instant' behavior so users immediately see the top of the new page.
    // Use both window and documentElement for cross-browser compatibility.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
